import { render, staticRenderFns } from "./commerce.vue?vue&type=template&id=42bf4b47&scoped=true&"
import script from "./commerce.vue?vue&type=script&lang=js&"
export * from "./commerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf4b47",
  null
  
)

export default component.exports